import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import { decryptToken } from '../utils/getToken';
import ImageModalEquip from '../Modal/ImageModalProd';

const TermsModal = ({ isOpen, setIsOpen, fetchData, selectedAttribute, isEdit, attributeId, categories }) => {
    const [name, setName] = useState('');
    const [baseName, setBaseName] = useState('');
    const [unit, setUnit] = useState('');
    const [status, setStatus] = useState(null);
    const [type, setType] = useState(null);
    const [image, setImage] = useState(null);
    const [showImageModal, setShowImageModal] = useState(false);
    const [images, setImages] = useState([]);
    const [loadButton, setLoadButton] = useState(false);

    const user = getDecryptedUserFromCookie();
    const urlmain = API_BASE_URL
    const statusOptions = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' },
    ];

    const TypeOptions = [
        { value: 'color', label: 'Color' },
        { value: 'size', label: 'Size' },
        { value: 'numbersize', label: 'numbersize' },
        { value: 'unit', label: 'Unit' },
        { value: 'other', label: 'Other' },
    ];
    const token = decryptToken("accessToken") || ""

    const fetchImages = async () => {
        try {
            const res = await fetch(`${urlmain}/api/images/${user.main_id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            const data = await res.json();
            setImages(data);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchImages();
    }, []);

    const handleImageSelect = (img) => {
        setImage(`${urlmain}${img.url}`);
    };


    useEffect(() => {
        if (isEdit && selectedAttribute) {
            const splitName = selectedAttribute.name?.split(' ');
            const lastWord = splitName?.[splitName.length - 1];
            const unitMatch = categories.find(cat => cat.name === lastWord);
            const inferredBaseName = unitMatch ? splitName.slice(0, -1).join(' ') : selectedAttribute.name;

            setBaseName(inferredBaseName);
            setName(selectedAttribute.name || '');
            setUnit(unitMatch?.name || '');
            setStatus(statusOptions.find(opt => opt.value === selectedAttribute.status));
            setType(TypeOptions.find(opt => opt.value === selectedAttribute.slug));
            setImage(selectedAttribute.image)
        } else {
            setBaseName('');
            setName('');
            setStatus(null);
            setType(null);
            setUnit('');
            setImage("");
        }
    }, [selectedAttribute, isEdit, categories]);

  
    const handleSubmit = async (e) => {
        setLoadButton(true);
        e.preventDefault();
      
    if (!name) {
        toast.error("Name is required", { position: "top-center", autoClose: 2000 });
        return;
    }
    
        try {
            const payload = {
                name,
                status: status?.value || '',
                attributeId: attributeId,
                slug: type?.value || "",
                unit: unit,
                user_id: user.main_id,
                user_name: user.full_name,
                image: image
            };

            const url = isEdit
                ? `${urlmain}/terms/single/${selectedAttribute.id}`
                : `${urlmain}/terms/admin1997`;

            const method = isEdit ? 'PUT' : 'POST';

            const response = await fetch(url, {
                method,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(payload)
            });

            const res = await response.json();
            if (response.ok) {
                toast.success(isEdit ? "Terms updated" : "Terms created", { position: "top-center", autoClose: 2000 });
                fetchData();
                setIsOpen(false);
            }
        } catch (error) {
            toast.error("Something went wrong", { position: "top-center", autoClose: 2000 });
        } finally{
            setLoadButton(false)
        }
    };

    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" >
            <div className="custom-modal-content" >
                <h2 className="oms-modal-title">{isEdit ? "Edit Terms" : "Terms Details"}</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>
                    <div className="oms-form-group">
                        <label>Name</label>
                        <input
                            type="text"
                            value={baseName}
                            onChange={(e) => {
                                const newBase = e.target.value;
                                setBaseName(newBase);
                                if (type?.value === 'unit' && unit) {
                                    setName(`${newBase} ${unit}`);
                                } else {
                                    setName(newBase);
                                }
                            }}
                            
                        />

                    </div>
                    <div className="oms-form-group ome-form-button2">
                        <label htmlFor="image" className="oms-form-label">Image</label>
                        <button type="button" onClick={() => setShowImageModal(true)}>Upload Main Image</button>
                        <div>
                            {image && (
                                <img src={image} alt="Selected" style={{ width: 80, marginTop: 10 }} />
                            )}
                        </div>
                    </div>

                    <ImageModalEquip
                        show={showImageModal}
                        handleClose={() => setShowImageModal(false)}
                        images={images}
                        onImageSelect={handleImageSelect}
                        multiple={false}
                        setImages={setImages}
                    />


                    <div className="oms-form-group">
                        <label>Type</label>
                        <Select options={TypeOptions} value={type} onChange={setType} />
                    </div>
                    {
                        type?.value === "unit" ?
                            <div className="oms-form-group">
                                <label>Unit/Params</label>
                                <Select
                                    options={categories.map(cat => ({ label: cat.name, value: cat.name }))}
                                    value={categories.find(cat => cat.name === unit) ? { label: unit, value: unit } : null}
                                    onChange={(e) => {
                                        const newUnit = e.value;
                                        setUnit(newUnit);
                                        setName(`${baseName} ${newUnit}`);
                                    }}
                                />

                            </div> : null
                    }
                    <div className="oms-form-group">
                        <label>Status</label>
                        <Select options={statusOptions} value={status} onChange={setStatus} />
                    </div>

                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>Cancel</button>
                        {
                            loadButton? <button type="button">{isEdit ? "Updating..." : "Submiting..."}</button>:
                            <button type="submit">{isEdit ? "Update" : "Submit"}</button>
                        }
                        
                    </div>
                </form>
            </div>
        </div>
    );
};


export default TermsModal;
